export class NoMessagesFoundError extends Error {
    constructor(m?: string) {
        if (!m) {
            m = 'No messages found.';
        }
        super(m);
    }
}